import React from "react";
import { useTranslation } from "react-i18next";
import Select from "../Select/Select";

const languages = [
   { code: "pt-BR", name: "common.ptBR", emoji: "🇧🇷" },
   { code: "es", name: "common.es", emoji: "🇪🇸" },
   { code: "en", name: "common.en", emoji: "🇺🇸" },
];

const LanguageSwitcher = () => {
   const { i18n, t } = useTranslation();

   return (
      <>
         <div className="w-full! mt-3.5!">
            <Select
               options={languages.map((lang) => ({ value: lang.code, text: `${lang.emoji} ${t(lang.name)}` }))}
               onChange={(e) => i18n.changeLanguage(e.target.value)}
               value={i18n.language}
            />
         </div>
      </>
   );
};

export default LanguageSwitcher;